import { render, staticRenderFns } from "./I-0-4-1-2-4__IR-Financial Information_edit-year-report.vue?vue&type=template&id=4b9aa812&"
import script from "./I-0-4-1-2-4__IR-Financial Information_edit-year-report.vue?vue&type=script&lang=js&"
export * from "./I-0-4-1-2-4__IR-Financial Information_edit-year-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports